import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { intl } from "LocaleWrapper";

type ShipOwnerSelectOption = {
	id: number | null;
	name: string;
}

const ShipOwnerSelect = ({ skipper, shipManager, ...rest }: {
	skipper: ShipOwnerSelectOption | null;
	shipManager: ShipOwnerSelectOption | null;
} & Omit<SelectProps<ShipOwnerSelectOption, false>, "multiple" | "fetchOptions" | "paginated">) => {

	skipper = skipper ?? { id: null, name: intl.formatMessage({ id: "NEW_SKIPPER_RELATION" }) };

	return (
		<Select
			fetchOptions={[ skipper, shipManager ].filter((option): option is ShipOwnerSelectOption => !!option)}
			getOptionLabel={option => option.name}
			clearable={false}
			disableSearch
			{...rest}
			value={rest.value ?? skipper}
		/>
	);
};

export default ShipOwnerSelect;
